// extracted by mini-css-extract-plugin
module.exports = {"container":"slidingButtonStyle_container__27mTG","plus":"slidingButtonStyle_plus__3t45C","title":"slidingButtonStyle_title__1icw4"};